import React from 'react';
import { Quote } from 'lucide-react';
import { testimonialsData } from '../../data/mockData';

export const Testimonials = () => {
  return (
    <section className="py-24 bg-[rgb(26,28,30)]">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            It's all about a dialogue
          </h2>
          <p className="text-xl text-[rgb(218,218,218)] max-w-3xl mx-auto">
            A few words from our clients
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonialsData.map((testimonial) => (
            <div
              key={testimonial.id}
              className="bg-[rgb(17,17,19)] border border-[rgba(255,255,255,0.1)] rounded-2xl p-8 hover:-translate-y-2 transition-all duration-300 hover:border-[rgb(0,250,99)] relative overflow-hidden group"
            >
              {/* Top Accent */}
              <div className="absolute top-0 left-0 right-0 h-0.5 bg-[rgb(0,250,99)] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

              {/* Quote Icon */}
              <div className="w-12 h-12 rounded-xl bg-[rgba(0,250,99,0.1)] flex items-center justify-center mb-6">
                <Quote size={24} className="text-[rgb(0,250,99)]" />
              </div>

              {/* Quote Text */}
              <p className="text-[rgb(218,218,218)] leading-relaxed mb-8 italic">
                "{testimonial.quote}"
              </p>

              {/* Author Info */}
              <div className="border-t border-[rgba(255,255,255,0.1)] pt-6">
                <div className="font-semibold text-white text-lg">
                  {testimonial.author}
                </div>
                <div className="text-[rgb(161,161,170)] text-sm mt-1">
                  {testimonial.position}, {testimonial.company}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
